import React from 'react';
import { Redirect  } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner'



class ModalCancelOrderConfirmation extends React.Component {

    state = {
        redirect: null,
        loading : false,
        IsCouplingRooms:false,
        HasConnectionDoor:false
    }

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });

            console.log('ModalOrder componentDidMount props: ', this.props);     
    }



    doCancelOrder = () => {

        if(this.state.loading) {
            return;
        }
        
        this.setState({ loading: true});
        const { employeeOrder } = this.props;
        this.props.doCancelOrder(employeeOrder.Id);

    }

    doNotCancelOrder = () => {
        if(this.state.loading) {
            return;
        }
        this.props.doNotCancelOrder();

    }
    

    backHomePage = () => {
        this.setState({ redirect: "/" }); 
    }


    setModalOrderConfirmationClosed = () =>  {

        if(this.state.loading) {
            return;
        }
        this.setState({ redirect: "/" }); 
    }
    

  render() {

    
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    } 
    
    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg2" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderConfirmationClosed}></div>

                            <div className="modal_order_inner_bg">
                              
                                    <div className="modal_order_top">                            
                                        <div className="modal_order_title1"> 
                                        ביטול הזמנה
                                        </div>
                                    </div>
                                    <div className="modal_order_title_hotel">
                                    
                                    </div>

                                    <div className="cntered-flex order_cancel_text directionRtl">
                                        ע"פ בקשתך הזמנה למלון   
                                        &nbsp;
                                       {this.props.employeeOrder.HotelName}
                                       <br />
                                       בתאריך 
                                       &nbsp;
                                       {this.props.employeeOrder.StartVacationDateFormatted}
                                       &nbsp;
                                       תבוטל
                                    </div>

                                <div className="modal_order_confirmation_container">
                                
                                    <div className="cntered-flex marginTop20">
                                        <div className="order_cancel_main_button"
                                                onClick={() => this.doCancelOrder()}>
                                            
                                            {(this.state.loading) ?
                                             <span className="hp_search_main_button_title">
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"                                        
                                                />      
                                                </span>
                                                : null}
                                            <span className="hp_search_main_button_title">
                                            כן 
                                            </span>
                                        </div>
                                        &nbsp; &nbsp; &nbsp;
                                        <div className="order_cancel_main_button"
                                                onClick={() => this.doNotCancelOrder()}>
                                            <span className="hp_search_main_button_title">
                                            לא 
                                            </span>
                                        </div>
                                    </div>
                                            
                                </div>

                            </div>

                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}


export default ModalCancelOrderConfirmation;
